// removed by extract-text-webpack-plugin
module.exports = {"gw-visuallyhidden":"visuallyhidden-hashed__gw-visuallyhidden__2gdQx"};


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/platform/widgets/loading/visuallyhidden-hashed.scss
// module id = 704
// module chunks = 0